import React, { useState } from 'react';
import { Navigation, MapPin, Eye, EyeOff } from 'lucide-react';

/**
 * A button component that links to Google Maps directions and shows coordinates
 * @param {Object} props - Component props
 * @param {Object} props.coordinates - Location coordinates with latitude and longitude
 * @returns {JSX.Element|null} - Direction button or null if coordinates not available
 */
const DirectionsButton = ({ coordinates }) => {
  const [showCoordinates, setShowCoordinates] = useState(false);
  
  if (!coordinates || !coordinates.latitude || !coordinates.longitude) {
    return (
      <div className="text-xs text-gray-500 italic mt-1">
        <MapPin className="inline-block mr-1 h-3 w-3" />
        No GPS coordinates available
      </div>
    );
  }
  
  // Format coordinates to 6 decimal places
  const lat = parseFloat(coordinates.latitude).toFixed(6);
  const lng = parseFloat(coordinates.longitude).toFixed(6);
  
  return (
    <div className="mt-2 flex flex-col space-y-2">
      <a 
        href={`https://www.google.com/maps/dir/?api=1&destination=${lat},${lng}`}
        target="_blank"
        rel="noopener noreferrer"
        className="inline-flex items-center px-2 py-1 text-xs font-medium text-white bg-blue-600 rounded hover:bg-blue-700"
      >
        <Navigation className="mr-1 h-3 w-3" />
        Get Directions
      </a>
      
      <div className="flex items-center">
        <button 
          onClick={() => setShowCoordinates(!showCoordinates)}
          className="inline-flex items-center text-xs text-blue-600 hover:text-blue-800"
          title={showCoordinates ? "Hide coordinates" : "Show coordinates"}
        >
          {showCoordinates ? (
            <>
              <EyeOff className="mr-1 h-3 w-3" />
              Hide Coordinates
            </>
          ) : (
            <>
              <Eye className="mr-1 h-3 w-3" />
              Show Coordinates
            </>
          )}
        </button>
      </div>
      
      {showCoordinates && (
        <div className="text-xs bg-gray-100 p-1 rounded border border-gray-200">
          <div><strong>Latitude:</strong> {lat}</div>
          <div><strong>Longitude:</strong> {lng}</div>
        </div>
      )}
    </div>
  );
};

export default DirectionsButton;
